<template>
    <v-footer padless>
        <v-card class="flex" flat tile>
            <v-container fluid class="px-4" style="display:none;">
                <v-divider class="pb-3"></v-divider>
                <v-card class="px-3" tile flat>
                    <sponsorbanner :multiplier="50" :spaceModifier="'space-between'"></sponsorbanner>
                </v-card>
            </v-container>
            <!--
            <v-card-title class="py-2 bg-primary">
                <v-container :class="'d-flex align-center py-0' + getMobileClasses()" fluid>
                    <div class="text-h6 d-inline-block font-weight-medium" style="color: white;">Tritt in Kontakt mit uns!</div>
                    <v-spacer></v-spacer>
                    <div class="d-flex">
                        <v-btn
                            v-for="(button, index) in social_media"
                            :key="index"
                            color="white"
                            icon
                            rounded
                            class="my-0 my-md-2 footer-icon"
                        >
                            <v-icon size="2rem">
                                {{"mdi-" + button.icon}}
                            </v-icon>
                        </v-btn>
                    </div>
                </v-container>
            </v-card-title>
            -->
            <v-card-text class="bg-dark py-2">
                <v-container :class="'d-flex white--text py-0' + getMobileClasses()" fluid>
                    <div class="d-flex align-center">
                        <v-icon :size="$vuetify.breakpoint.smAndDown ? '1rem' : '1.375rem'" class="mr-2" color="white">
                            mdi-copyright
                        </v-icon>
                        <div class="d-inline" style="vertical-align: middle; padding-top: 1px;">
                            {{ new Date().getFullYear() + " Aktion Zukunft"}}
                        </div>
                    </div>
                    <v-spacer></v-spacer>
                    <div>
                        <v-btn text tile color="white" @click="$router.push('/legal/imprint')">
                            Impressum
                        </v-btn>
                        <v-btn text tile color="white" @click="$router.push('/legal/privacy')">
                            Datenschutz
                        </v-btn>
                    </div>
                </v-container>
            </v-card-text>
        </v-card>
    </v-footer>
</template>

<script>
import Sponsorbanner from "./SponsorBanner.vue";

export default {
    components: {
        Sponsorbanner
    },
    data: () => ({
        social_media: [
            {
                icon: "facebook",
                url: ""
            },
            {
                icon: "email-outline",
                url: ""
            },
            {
                icon: "instagram",
                url: ""
            }
        ]
    }),
    methods: {
        getMobileClasses() {
            if(this.$vuetify.breakpoint.smAndDown) {
                return " align-center flex-column";
            }

            return "";
        }
    }
}
</script>

<style lang="scss">
.footer-icon {
  margin: 0px 20px;
}

@media (min-width: 960px) {
}
</style>